
import {CreateApiHandler} from '../../common/helpers/thunkMiddleware';
import {HiverAxios} from '../../common/helpers/HiverAxios';

import { DOWNLOAD_USERS_LIST } from './types';

function initiateDownload() {
    return new Promise((res, rej) => {
        HiverAxios({
            url: '/api/settings/users/export',
            type: 'GET',
            callback: (response) => { res(response) },
            onfail: (err) => { rej(err) }
        });
    })
}

export const downloadUsersList = CreateApiHandler(initiateDownload, DOWNLOAD_USERS_LIST, {
    errorMessage: "Oops! The download failed. Please try again"
})